
export const serviceFields = ['NodId', 'ParId', 'LtCnt', 'RtCnt', 'SrtId', 'NDeep', 'Owner', 'Gwner', 'Mfier', 
    'NFlag', 'NPerm', 'NType', 'SrtBy', 'mod', 'CDate', 'MDate'];
